import React from 'react'
import { useMutation } from '@tanstack/react-query'
import { useVenti } from 'venti'
import {
	CreateInviteRequest,
	Invite,
	SiteConfiguration,
} from '@matech/thebigpos-sdk'
import { ModalWizard } from './ModalWizard'
import inviteCoBorrowerQuestions from '../../workflows/portal-invite-coborrower-questions.json'
import { TheBigPOSApi } from '../../lib/TheBigPOSClient'
import { getErrorMessage } from '../../services/helper'
import { useAppContext } from '../AppContext'
import { getTheme } from '../../config'
import { useAlert } from '../../hooks'
import { FixMeLater } from '../../types'
import { useLoanContext } from '../../contexts/LoanContext'

const theme = getTheme()

const ModalInviteBorrower = () => {
	const ventiState = useVenti()
	const { state } = useAppContext()
	const { alert } = useAlert()
	const { loanId } = useLoanContext()

	const { siteConfig } = state as {
		siteConfig: SiteConfiguration | null
		invite?: Invite | null
	}

	const inviteCoBorrower = !!ventiState.get(
		theme.storageKeys.inviteCoBorrower
	)

	const closeInviteModal = () => {
		ventiState.set(theme.storageKeys.inviteCoBorrower, false)
	}

	const inviteUserMutation = useMutation({
		mutationFn: (data: CreateInviteRequest) =>
			TheBigPOSApi.inviteUser(data),
		onError: (error) => {
			alert(getErrorMessage(error), { severity: 'error' })
			ventiState.set(
				theme.storageKeys.errorMessage,
				'An error occurred while attempting to send the invitation. Please try again later.'
			)
		},
		onSuccess: () => {
			alert('The invitation was sent successfully')
			ventiState.set(
				theme.storageKeys.successMessage,
				'The invitation was sent successfully.'
			)
			closeInviteModal()
		},
	})

	const sendInvitation = async (data: FixMeLater) => {
		if (!siteConfig) {
			return
		}

		const additionalData = {
			sourceURL: `https://${siteConfig.url}/verify/invite`,
			siteConfigurationID: siteConfig.id,
			loanRole: 'CoBorrower',
			loanID: loanId,
		}

		if (loanId) {
			inviteUserMutation.mutate({
				...data,
				...additionalData,
			})
		} else if (data?.EmailAddress) {
			inviteUserMutation.mutate({
				loanID: loanId,
				loanRole: 'CoBorrower',
				...data,
			})
		}
	}

	return (
		<ModalWizard
			modal={inviteCoBorrower}
			setModal={closeInviteModal}
			questions={inviteCoBorrowerQuestions}
			save={sendInvitation}
			finalButtonText="Send Invitation"
			modalTitle=""
			modalData={undefined}
			type={undefined}
		/>
	)
}

export default ModalInviteBorrower
